import { AsyncPipe, CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Optional,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { LocalizationPipe } from '@abp/ng.core';
import { NavbarRoutesComponent, TranslatePipe } from '@volo/ngx-lepton-x.core';
import { FacultyManagementPendingApprovalCountService } from '../faculty-management-pending-approval-count.service';

@Component({
  selector: 'sgu-routes',
  templateUrl: './sgu-routes.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    NavbarRoutesComponent,
    LocalizationPipe,
    TranslatePipe,
  ],
})
export class SguRoutesComponent {
  @ViewChild('facultyManagementTemplate', { static: true })
  facultyManagementTemplate!: TemplateRef<any>;

  readonly pendingCount$: Observable<number>;

  constructor(
    @Optional() @Inject('REPLACEABLE_DATA') private readonly replaceableData: any,
    pendingApprovalCount: FacultyManagementPendingApprovalCountService
  ) {
    this.pendingCount$ = pendingApprovalCount.count$;
  }

  get navbarItems(): any[] {
    return this.replaceableData?.inputs?.navbarItems ?? [];
  }

  get groupItems(): any[] {
    return this.replaceableData?.inputs?.groupItems ?? [];
  }

  isAbpLocalizationKey(text: unknown): boolean {
    return typeof text === 'string' && text.split('::').length > 1;
  }

  decorateItems(items: any[] | null | undefined): any[] {
    if (!Array.isArray(items) || !this.facultyManagementTemplate) {
      return Array.isArray(items) ? items : [];
    }

    for (const item of items) {
      this.decorateItem(item);
    }

    return items;
  }

  decorateGroupedItems(groups: any[] | null | undefined): any[] {
    if (!Array.isArray(groups) || !this.facultyManagementTemplate) {
      return Array.isArray(groups) ? groups : [];
    }

    for (const group of groups) {
      if (Array.isArray(group?.items)) {
        for (const item of group.items) {
          this.decorateItem(item);
        }
      }
    }

    return groups;
  }

  private decorateItem(item: any): void {
    if (!item || typeof item !== 'object') {
      return;
    }

    if (item.link === '/faculty-management') {
      item.template = this.facultyManagementTemplate;
    }
  }
}
